export default "__VITE_ASSET__t6UJvCzr__"